import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import ChromeIcon from '../assets/chromeIcon.svg';

export const HeroSection: React.FC = () => {
  return (
    <Container fluid className="d-flex justify-content-center hero-section">
      <Row className="w-100 justify-content-center">
        <Col
          xs={12}
          md={10}
          lg={9}
          xl={8}
          className="d-flex flex-column align-items-center text-center hero-section__col"
        >
          <div className="hero-section__subtitle">
            GENERATE VIRAL LINKEDIN POSTS IN SECONDS
          </div>

          <div className="hero-section__headline">
            Brand. Growth.<br className="hero-section__headline-break" />{' '}
            <span className="hero-section__headline-accent">Cero.</span>
          </div>

          <div className="d-flex flex-column align-items-center hero-section__cta">
            <a
              className="hero-section__chrome-btn"
              href="https://chromewebstore.google.com/detail/cero-linkedin-personal-br/moeocagahkkomhnekdhlfjbmomkjoddj?hl=en"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Image
                src={ChromeIcon}
                alt="Add to Chrome"
                className="hero-section__chrome-icon"
              />
              <span>Add to Chrome</span>
            </a>
          </div>
        </Col>
      </Row>
    </Container>
  );
};
